export default __webpack_public_path__ + "media/images/images/gallery/16-077c364fe9ccfe06127c6e0a4fe48e28.jpg";